import { faX } from "@fortawesome/free-solid-svg-icons";
import { BaseLogo } from "../../../core/models/entities/BaseLogo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export type LogoDimensionFormat =
  | "BWWXHYYMM"
  | "WWxYYmm"
  | "HYYmmMWXXmm"
  | "HYYmm";

export function LogoDimensions({
  logo,
  format: format = "BWWXHYYMM",
}: {
  logo: BaseLogo;
  format?: LogoDimensionFormat;
}) {
  switch (format) {
    case "BWWXHYYMM":
      return (
        <span>
          <b>W</b> {logo.widthMm} x <b>H</b> {logo.heightMm} MM
        </span>
      );

    case "WWxYYmm":
      return (
        <span>
          {logo.widthMm}x{logo.heightMm}mm
        </span>
      );

    case "HYYmmMWXXmm":
      return (
        <span>
          <b>Height</b> {logo.heightMm}mm <br /> <b>Max width</b> {logo.widthMm}
          mm
        </span>
      );

    case "HYYmm":
      return (
        <span>
          <b>Height</b> {logo.heightMm}mm
        </span>
      );
  }
}
